import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class TypeService {

  constructor(
    private http: HttpClient
  ) { }

  getTypes():Observable<any>{
    return this.http.get(Services.types).pipe(
      tap(staffs => console.info(`fetched types`))
    );
  }
}
